import { useDeleteRest } from './hooks/useDeleteRest'
import { useDeleteShift } from './hooks/useDeleteShift'
import { useDuplicateRest } from './hooks/useDuplicateRest'
import { useDuplicateShift } from './hooks/useDuplicateShift'
import { useFetchHeader } from './hooks/useFetchHeader'
import { useFetchRows } from './hooks/useFetchRows'
import { useMoveRest } from './hooks/useMoveRest'
import { useMoveShift } from './hooks/useMoveShift'
import { planningEngineServiceInvalidations } from './planningEngine.cacheKeys'

class PlanningEngineService {
  row = {
    useFetchRows,
    invalidateRows: planningEngineServiceInvalidations.invalidateRows
  }

  header = {
    useFetchHeader,
    invalidateHeader: planningEngineServiceInvalidations.invalidateHeader
  }

  shift = {
    useMoveShift,
    useDuplicateShift,
    useDeleteShift
  }

  rest = {
    useMoveRest,
    useDuplicateRest,
    useDeleteRest
  }
}

export const planningEngineService = new PlanningEngineService()
